import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';
import { AccountPath, getAccountUrl, getPartnerUrl, getPath, Path } from 'urlBuilder';

export const finishLoginFlow = (options: { app?: domain.SsoLoginApplication; postAction?: string }) => {
    storageService.setAuthenticated(true);

    if (options.app) {
        let appUrl;

        switch (options.app) {
            case domain.SsoLoginApplication.Account:
                appUrl = getAccountUrl(AccountPath.root);
                break;

            case domain.SsoLoginApplication.Partner:
                appUrl = getPartnerUrl();
                break;

            default:
                throw errorHelpers.assertNever(options.app);
        }

        if (options.postAction) {
            appUrl += options.postAction.startsWith('/') ? options.postAction : `/${options.postAction}`;
        }

        routingService.navigateToExternalUrl(appUrl);
    } else {
        routingService.reloadToUrl(options.postAction || getPath(Path.root));
    }
};
